/**
 * Human period labels for dashboard widgets (company / Pacific time).
 * When the window is "this quarter", returns Q1–Q4 for the current company quarter
 * so cards don't hardcode "Q3" or say a vague "this quarter".
 */
import moment from "moment";
import { companyToday } from "./companyTime";

const STATIC = {
  today: "today",
  yesterday: "yesterday",
  week: "this week",
  lastWeek: "last week",
  lastMonth: "last month",
  month: "this month",
  ytd: "this year",
  year: "this year",
};

/**
 * @param {string} win  today|yesterday|week|lastWeek|month|quarter|ytd|year|custom|follow
 * @param {{ from?: string, to?: string }|null} [custom]
 * @returns {string}
 */
export function periodWindowLabel(win, custom = null) {
  const id = !win || win === "follow" ? "month" : win;
  if (id === "quarter") {
    return `Q${companyToday().quarter()}`;
  }
  if (id === "custom" && custom?.from && custom?.to) {
    const a = moment(custom.from);
    const b = moment(custom.to);
    if (a.isValid() && b.isValid()) {
      return `${a.format("D MMM")} – ${b.format("D MMM")}`;
    }
  }
  return STATIC[id] || "this month";
}

/** Title-case variant for headers ("Q3", "This month"). */
export function periodWindowLabelTitle(win, custom = null) {
  const s = periodWindowLabel(win, custom);
  if (/^Q[1-4]$/.test(s)) return s;
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}
